import VizExAvatar from 'visitor-ui-component-library/avatar/VizExAvatar';
import SVGExpand from 'visitor-ui-component-library-icons/icons/SVGExpand';
import VizExIcon from 'visitor-ui-component-library/icon/VizExIcon';
import styled from 'styled-components';
import I18n from 'I18n';
import { useButton } from 'react-aria';
import { useCustomerAgentHover } from '../contexts/CustomerAgentHoverContext';
import { calculateChatWidgetWidth } from '../widget-dimensions/calculateChatWidgetWidth';
import { COMPOSER_INLINE_MARGIN } from '../widget-dimensions/constants/dimensions';
import { MIN_LAUNCHER_WIDTH } from './constants/launcherDimensions';
import { useTransitionAnimationCallbacks } from 'visitor-ui-component-library/utils/hooks/useTransitionAnimationCallback';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const IconWrapper = styled(VizExIcon).withConfig({
  displayName: "AskMeAnythingLauncher__IconWrapper"
})(["margin:auto 0;transition:transform 0.5s ease,opacity 0.5s ease;transform:", ";opacity:", ";"], ({
  $hovering
}) => $hovering ? 'opacity(1)' : 'opacity(0)', ({
  $hovering
}) => $hovering ? 1 : 0);
const AvatarGroup = styled.div.withConfig({
  displayName: "AskMeAnythingLauncher__AvatarGroup"
})(["position:relative;margin-right:10px;display:flex;align-items:center;"]);
const AvatarWrapper = styled.div.withConfig({
  displayName: "AskMeAnythingLauncher__AvatarWrapper"
})(["align-self:center;display:flex;"]);
const LauncherContainer = styled.div.withConfig({
  displayName: "AskMeAnythingLauncher__LauncherContainer"
})(["border:1px solid #9aacc2;border-radius:27px;min-width:", "px;width:", ";padding:0 10px;display:flex;box-shadow:#dcdcdc 0px 0px 4px;transition:width 0.5s ease;min-height:40px;overflow:hidden;cursor:pointer;position:relative;background-color:white;&:hover{border-color:", ";}"], MIN_LAUNCHER_WIDTH, ({
  $width
}) => $width, ({
  $accentColor
}) => $accentColor);
const PlaceholderWrapper = styled.div.withConfig({
  displayName: "AskMeAnythingLauncher__PlaceholderWrapper"
})(["display:flex;flex:1;"]);
const Placeholder = styled.span.withConfig({
  displayName: "AskMeAnythingLauncher__Placeholder"
})(["margin:auto 0;white-space:nowrap;padding-right:20px;"]);
const AskMeAnythingLauncher = ({
  onOpen,
  coloring,
  placeholder = I18n.text('conversations-visitor-experience-components.askMeAnythingLauncher.placeholder'),
  avatarImageSrcs,
  browserWindowWidth,
  widgetSize,
  onLauncherAnimationStart,
  onLauncherAnimationFinished
}) => {
  const {
    isHoverActive: hovering,
    launcherRef,
    reducedLauncherWidth
  } = useCustomerAgentHover();
  const {
    ref: transitionRef
  } = useTransitionAnimationCallbacks({
    onTransitionStart: onLauncherAnimationStart,
    onTransitionEnd: onLauncherAnimationFinished
  });
  const {
    buttonProps
  } = useButton({
    onPress: onOpen,
    elementType: 'div',
    'aria-label': I18n.text('conversations-visitor-experience-components.visitorExperienceAriaLabels.open')
  }, transitionRef);
  const expandedLauncherWidth = calculateChatWidgetWidth(browserWindowWidth, widgetSize.width) - COMPOSER_INLINE_MARGIN * 2;
  const width = hovering ? `${expandedLauncherWidth}px` : `${reducedLauncherWidth}px`;
  const singleAvatarSrc = avatarImageSrcs.length > 0 ? [avatarImageSrcs[0]] : [];
  return /*#__PURE__*/_jsxs(LauncherContainer, Object.assign({}, buttonProps, {
    ref: transitionRef,
    "data-test-id": "ask-me-anything-launcher",
    $hovering: hovering,
    $width: width,
    $accentColor: coloring.accentColor,
    children: [/*#__PURE__*/_jsxs(PlaceholderWrapper, {
      ref: launcherRef,
      children: [/*#__PURE__*/_jsx(AvatarGroup, {
        children: singleAvatarSrc.map((avatarSrc, index) => /*#__PURE__*/_jsx(AvatarWrapper, {
          children: /*#__PURE__*/_jsx(VizExAvatar, {
            className: "chat-head-avatar",
            size: "sm",
            src: avatarSrc,
            alt: "avatar"
          })
        }, avatarSrc !== null && avatarSrc !== void 0 ? avatarSrc : index))
      }), /*#__PURE__*/_jsx(Placeholder, {
        children: placeholder
      })]
    }), /*#__PURE__*/_jsx(IconWrapper, {
      $hovering: hovering,
      icon: /*#__PURE__*/_jsx(SVGExpand, {
        color: coloring.accentColor
      })
    })]
  }));
};
AskMeAnythingLauncher.displayName = 'AskMeAnythingLauncher';
export default AskMeAnythingLauncher;